import React from 'react';
import { AlertTriangle, CheckCircle } from 'lucide-react';
import { adminProducts } from '../adminData';

function AdminInventory() {
  const lowStock = adminProducts.filter(p => p.stock < 30);
  const totalUnits = adminProducts.reduce((sum, p) => sum + p.stock, 0);

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h1>Inventory</h1>
          <p>Monitor stock levels and get low-stock alerts.</p>
        </div>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <h3>{totalUnits}</h3>
          <p>Total Units in Stock</p>
        </div>
        <div className="admin-stat-card">
          <h3>{adminProducts.length}</h3>
          <p>Total SKUs</p>
        </div>
        <div className="admin-stat-card">
          <h3>{lowStock.length}</h3>
          <p>Low Stock Alerts</p>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <h3>Stock Levels by Product</h3>
        </div>
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Category</th>
                <th>Stock Level</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {adminProducts.map(p => (
                <tr key={p.id}>
                  <td className="admin-td-name">{p.name}</td>
                  <td>{p.category}</td>
                  <td style={{ minWidth: 160 }}>
                    <div className="admin-stock-bar-track">
                      <div
                        className={`admin-stock-bar-fill ${p.stock < 30 ? 'low' : ''}`}
                        style={{ width: `${Math.min((p.stock / 100) * 100, 100)}%` }}
                      ></div>
                    </div>
                  </td>
                  <td>
                    {p.stock < 30 ? (
                      <span className="admin-status-pill status-pending"><AlertTriangle size={12} /> Low Stock</span>
                    ) : (
                      <span className="admin-status-pill status-completed"><CheckCircle size={12} /> In Stock</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminInventory;
